<template>
	<form-group-input
		v-loading="loading"
		:disabled="disabled"
		:label="label ? label : $t('eshop.deliveryPoints')"
		:required="required">
		<el-select
			ref="containerSelect"
			v-model="selectedValue"
			data-cy="container"
			:disabled="disabled"
			:placeholder="$t('eshop.containerSearchHint')"
			class="select-default container-select"
			remote
			:remote-method="filterFreeContainers"
			filterable
			:clearable="clearable"
			@visible-change="onVisibleChange">
			<template slot="prefix">
				<span v-if="selectedContainer" class="container-icon-in-select-box">
					<img v-if="selectedContainer.containerType === containerTypes.store" src="/static/img/icons/genesis.svg" alt="Genesis">
					<img v-if="selectedContainer.containerType === containerTypes.penguinBox" src="/static/img/icons/pb.svg" alt="PB">
					<span v-if="selectedContainer.containerType === containerTypes.privateAddress" class="text-dark">
						<i class="fa fa-home" aria-hidden="false" />
					</span>
					<span v-if="selectedContainer.containerType === containerTypes.smartBox" class="text-dark">
						<i class="nc-icon nc-mobile" aria-hidden="false" />
					</span>
				</span>
			</template>
			<el-option
				v-for="option in displayOptions"
				:key="option.containerId"
				data-cy="select-container"
				:label="formatContainerName(option)"
				:value="option.containerId">
				<img v-if="option.containerType === containerTypes.store" src="/static/img/icons/genesis.svg" alt="Genesis">
				<img v-if="option.containerType === containerTypes.penguinBox" src="/static/img/icons/pb.svg" alt="PB">
				<i v-if="option.containerType === containerTypes.privateAddress" class="fa fa-home text-dark" />
				<i v-if="option.containerType === containerTypes.smartBox" class="nc-icon nc-mobile text-dark" />
				{{ formatContainerName(option) }}
			</el-option>
		</el-select>
	</form-group-input>
</template>

<script>
import { containerTypes } from '@/globalConstants';
import ContainerSelectMixin from '@/util/container-select-mixin';

export default {
	name: 'ContainerSelect',
	mixins: [ContainerSelectMixin],
	props: {
		value: {
			type: [String, Number],
			default: null,
		},
		loading: {
			type: Boolean,
			default: false,
		},
		disabled: {
			type: Boolean,
			default: false,
		},
		required: {
			type: Boolean,
			default: false,
		},
		email: {
			type: String,
			default: null,
		},
		label: {
			type: String,
			default: null,
		},
		clearable: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		return {
			containerTypes,
			freeContainers: [],
		};
	},
	computed: {
		selectedValue: {
			get() {
				return this.value;
			},
			set(value) {
				this.$emit('input', value);
			},
		},
		selectedContainer() {
			return this.freeContainers.find((container) => container.containerId === this.value);
		},
		displayOptions() {
			const options = [...this.freeContainersFiltered];
			if (this.selectedContainer && !options.find((opt) => opt.containerId === this.selectedContainer.containerId)) {
				options.unshift(this.selectedContainer);
			}
			return options;
		},
	},
	created() {
		this.getFreeContainers(this.email);
	},
	mounted() {
		this.setContainerSelectEventListener();
	},
	methods: {
		async getFreeContainers(email) {
			this.freeContainers = await this.$service.container.getFreeContainersWithExpired(email);
			if (!email) {
				this.freeContainers = this.freeContainers.filter((container) => container.containerType !== containerTypes.smartBox);
			}
			this.enrichFreeContainers(this.freeContainers);
		},
		formatContainerName(container) {
			return this.$options.filters.location(container);
		},
	},
};
</script>

<style scoped>
.container-select {
	width: 100%;
}

.container-icon-in-select-box {
	padding-left: 7px;
	padding-top: 10px;
	padding-bottom: 5px;
	display: flex;
	flex-direction: column;
	justify-content: center;
}

.container-icon-in-select-box img {
	width: 16px;
	height: 16px;
}

.container-icon-in-select-box i {
	font-size: 16px;
}
</style>
